<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<div *ngIf="!showLoading">

    <app-formular [formBuilderInput]="CoordinateSearchFormGroup" [formular]="searchMethodFormular"
        (action)="action($event)">
    </app-formular>


    <div *ngIf="CoordinateSearchFormGroup.value.SEARCH_METHOD == '1'">
        <app-formular [formBuilderInput]="CoordinateSearchFormGroup" [formular]="addressFormular"
            (action)="action($event)">
        </app-formular>
    </div>

    <div *ngIf="CoordinateSearchFormGroup.value.SEARCH_METHOD == '2'">
        <app-formular [formBuilderInput]="CoordinateSearchFormGroup" [formular]="parcelFormular"
            (action)="action($event)">
        </app-formular>
    </div>

    <div *ngIf="CoordinateSearchFormGroup.value.SEARCH_METHOD == '3'">
        <app-formular [formBuilderInput]="CoordinateSearchFormGroup" [formular]="manualRequestFormular" [groupName]="groupName"
            (action)="action($event)">
        </app-formular>
    </div>

    <div *ngIf="CoordinateSearchFormGroup.value.SEARCH_METHOD == '4'">
        <app-formular [formBuilderInput]="CoordinateSearchFormGroup" [formular]="coordinateFormular"
            (action)="action($event)">
        </app-formular>
    </div>
    <div>
        <button *ngIf="router.url != '/gipReqMan'" (click) = "btnBackAction()" mat-raised-button matStepperPrevious>{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
        <button mat-raised-button matStepperNext>{{"Next" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    </div>
</div>